import { Stack, Switch as MuiSwitch, Typography } from "@mui/material";

export function FrmSwitch(props) {
  // there must always be two and only two options for a Switch; the first
  // will be the left side of the switch, and the second the right side
  const { checked, name, onChange, options } = props;
  return (
    <Stack direction="row" alignItems="center">
      <Typography>{options[0].name}</Typography>
      <MuiSwitch
        checked={checked}
        name={name}
        onChange={(e) =>
          onChange(e.target.name, e.target.checked ? options[1] : options[0])
        }
      />
      <Typography>{options[1].name}</Typography>
    </Stack>
  );
}
